import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('widget-card', {
    attrs: {
      "widget": _vm.widget,
      "data-set": _vm.dataSet,
      "is-loading": _vm.isLoading,
      "dashboard-id": _vm.dashboardId,
      "edit-mode": _vm.editMode,
      "date-range": _vm.dateRange,
      "custom-parameters": _vm.customParameters
    },
    on: {
      "refresh-data": function ($event) {
        return _vm.$emit('refresh-data');
      },
      "activate-sub-dashboard": function ($event) {
        return _vm.$emit('activate-sub-dashboard', $event);
      },
      "show-in-full-screen": function ($event) {
        _vm.showInFullScreen = true;
      }
    }
  }), _c(VDialog, {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: _vm.showInFullScreen,
      callback: function ($$v) {
        _vm.showInFullScreen = $$v;
      },
      expression: "showInFullScreen"
    }
  }, [_c('widget-card', {
    attrs: {
      "widget": _vm.widget,
      "data-set": _vm.dataSet,
      "is-loading": _vm.isLoading,
      "dashboard-id": _vm.dashboardId,
      "edit-mode": _vm.editMode,
      "date-range": _vm.dateRange,
      "custom-parameters": _vm.customParameters
    },
    on: {
      "refresh-data": function ($event) {
        return _vm.$emit('refresh-data');
      },
      "activate-sub-dashboard": function ($event) {
        return _vm.$emit('activate-sub-dashboard', $event);
      },
      "close-full-screen": function ($event) {
        _vm.showInFullScreen = false;
      }
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };